class SearchForm extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input[type="search"]');
    this.resetButton = this.querySelector('button[type="reset"]');

    if (this.input) {
      this.input.form.addEventListener('reset', this.onFormReset.bind(this));
      this.input.addEventListener(
        'input',
        debounce((event) => {
          this.onChange(event);
        }, 300).bind(this)
      );
      // Predictive search registers its own submit listener and calls back into
      // onFormSubmit via super, so only bind here for the plain <search-form>.
      if (this.tagName.toLowerCase() === 'search-form') {
        this.input.form.addEventListener('submit', this.onFormSubmit.bind(this));
      }
    }
  }

  toggleResetButton() {
    const resetIsHidden = this.resetButton.classList.contains('hidden');
    if (this.input.value.length > 0 && resetIsHidden) {
      this.resetButton.classList.remove('hidden');
    } else if (this.input.value.length === 0 && !resetIsHidden) {
      this.resetButton.classList.add('hidden');
    }
  }

  onChange() {
    this.toggleResetButton();
  }

  shouldResetForm() {
    return !document.querySelector('[aria-selected="true"] a');
  }

  onFormReset(event) {
    // Prevent default so the form reset doesn't set the value gotten from the url on page load
    event.preventDefault();
    // Don't reset if the user has selected an element on the predictive search dropdown
    if (this.shouldResetForm()) {
      this.input.value = '';
      this.input.focus();
      this.toggleResetButton();
    }
  }

  // Recognizes phrases like "under $60", "under 60", "below $60",
  // "less than 60", "cheaper than 60" (case-insensitive) and pulls out
  // the numeric ceiling so it can drive the native price filter instead
  // of being treated as literal search text.
  parsePriceQuery(raw) {
    const pattern = /\b(?:under|below|less than|cheaper than)\s*\$?\s*(\d+(?:\.\d{1,2})?)\b/i;
    const match = raw.match(pattern);
    if (!match) return null;
    const max = match[1];
    const cleaned = raw.replace(match[0], '').replace(/\s{2,}/g, ' ').trim();
    return { terms: cleaned, max: max };
  }

  onFormSubmit(event) {
    if (!this.input || !this.input.value) return;
    const parsed = this.parsePriceQuery(this.input.value);
    if (!parsed) return;

    event.preventDefault();
    const params = new URLSearchParams();
    // A blank remainder (e.g. the query was just "under 60") still needs a
    // value Shopify's search endpoint will treat as "match everything" so
    // the price filter is the only real constraint.
    params.set('q', parsed.terms || '*');
    params.set('options[prefix]', 'last');
    params.set('filter.v.price.lte', parsed.max);
    window.location.href = '/search?' + params.toString();
  }
}

customElements.define('search-form', SearchForm);
